import { render, staticRenderFns } from "./bubble.vue?vue&type=template&id=7b96d62f"
import script from "./bubble.vue?vue&type=script&lang=js"
export * from "./bubble.vue?vue&type=script&lang=js"
import style0 from "./bubble.vue?vue&type=style&index=0&id=7b96d62f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports